import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MessageService } from 'primeng/api';
import { AppModule } from 'src/app/app.module';
import { AuthService } from 'src/app/modules/common/service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
  styleUrl: './app.login.component.scss'
})
export class AppLoginComponent {
  // endPointUrl: string = 'http://192.168.1.197:8899/api/';
  showResetFlow = false;
  loginForm: FormGroup;

  // showResetDialog = false;
  resetEmail = '';
  otp: string[] = Array(6).fill('');
  newPassword = '';
  confirmPassword = '';
  step = 1;
  activeTabIndex = 0;
  step3Form!: FormGroup;
  loading = false

  tabs = [
    { label: 'Internal User' },
    { label: 'External User' }
  ];
  showPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private msalService: MsalService,
    private auth: AuthService,
    private message: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern('^(?! )[a-zA-Z0-9_\\.#$%&^`{|}~\\+\\-/\\!\'*\\+\\-/=\\?"]+@([a-zA-Z0-9-]+[.]){1,2}[a-zA-Z]+ *$')
      ]),
      password: new FormControl('', [Validators.required]),
    });


    this.step3Form = this.fb.group({
      newPassword: ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/)
      ]],
      confirmPassword: ['', Validators.required]
    }, {
      validators: this.passwordsMatchValidator
    });
  }
  passwordsMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  }
  loginFun = async (): Promise<void> => {
    const endpoint = environment.baseApiUrl + 'token';
    if (this.loginForm.invalid) {
      this.message.add({
        severity: 'error',
        summary: 'Error',
        detail: 'User ID and Password cannot be empty.',
      });
      return;
    }
    try {
      this.loading = true
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.loginForm.value),
      });

      localStorage.setItem('manual-logged-in', 'true');

      const text = await response.text();
      let data: any;

      try {
        data = JSON.parse(text);
      } catch {
        data = null;
      }

      if (response.ok && data?.access) {
        this.message.add({
          severity: 'success',
          summary: 'Login Successful',
          detail: 'Welcome!',
        });

        localStorage.setItem('token', data.access);
        if(this.userType == 5){
          this.router.navigate(['/user/search/application']);
        }else{
          this.router.navigate(['/user/search/document-grid']);
        }
        
      } else {
        this.message.add({
          severity: 'error',
          summary: 'Login Failed',
          detail: data?.message || 'Invalid credentials',
        });
      }
    } catch (err) {
      console.error('Login error:', err);
      this.message.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Network error or server unavailable',
      });
    } finally {
      
      this.loading = false
    }
  };
  goToStep(stepNumber: number) {
    this.step = stepNumber;

    if (stepNumber === 1) {
      this.failedAttempts = false;
      this.otp = ['', '', '', '', '', ''];
      this.resetEmail = null;
    }

    if (stepNumber === 2) {
      this.otp = ['', '', '', '', '', ''];
    }
  }
  async login() {
    await this.msalService.loginRedirect();
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  // Reset Password Logic
  // async sendOtp() {
  //   if (!this.resetEmail) return;

  //   try {
  //     const response = await fetch(this.endPointUrl + 'user/v1/password/forgot', {
  //       method: 'PUT',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ email: this.resetEmail })
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       this.message.add({
  //         severity: 'success',
  //         summary: 'OTP Sent',
  //         detail: data.message || 'Please check your email' 
  //       });
  //       this.step = 2;
  //     } else {
  //       this.message.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: data.message || 'Failed to Send OTP'
  //       });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     this.message.add({
  //       severity: 'error',
  //       summary: 'Network Error',
  //       detail: 'Failed to send request. Please try again later.'
  //     });
  //   }
  // }

  resendCountdown: number = 180;
  resendTimer: any;
  // isValidEmail(email: string): boolean {
  //   const emailRegex = /^(?! )[a-zA-Z0-9_\.#$%&\^`{|}~+\-\/!'*\+\-\/=?"]+@([a-zA-Z0-9-]+\.){1,2}[a-zA-Z]+ *$/;
  //   return emailRegex.test(email);
  // }
  emailPattern = /^(?! )[a-zA-Z0-9_.#$%&^`{|}~+\-/!'*+=?"]+@([a-zA-Z0-9-]+\.){1,2}[a-zA-Z]+ *$/;
  // Called when sending OTP for the first time
  async sendOtp() {
    if (!this.resetEmail) {
      this.message.add({
        severity: 'warn',
        summary: 'Email Required',
        detail: 'Please enter your email address'
      });
      return;
    } else if (!this.emailPattern.test(this.resetEmail)) {
      this.message.add({
        severity: 'warn',
        summary: 'Invalid Email',
        detail: 'Please enter a valid email address'
      });
      return;
    }
    this.loading = true
    try {
      const response = await fetch(environment.baseApiUrl + 'user/v1/password/forgot', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.resetEmail })
      });

      const data = await response.json();

      if (response.ok) {
        this.message.add({
          severity: 'success',
          summary: 'OTP Sent',
          detail: data.message || 'Please check your email'
        });
        this.step = 2;
        this.startResendCountdown();
      } else {
        this.message.add({
          severity: 'error',
          summary: 'Error',
          detail: data.message || 'Failed to Send OTP'
        });
      }
    } catch (err) {
      console.error(err);
      this.message.add({
        severity: 'error',
        summary: 'Network Error',
        detail: 'Failed to send request. Please try again later.'
      });
    } finally {
      this.loading = false
    }
  }
  startResendCountdown() {
    this.resendCountdown = 180;

    if (this.resendTimer) clearInterval(this.resendTimer);

    this.resendTimer = setInterval(() => {
      if (this.resendCountdown > 0) {
        this.resendCountdown--;
      } else {
        clearInterval(this.resendTimer);

      }
    }, 1000);
  }
  // async resendOtp() {
  //   this.otp = ['','','','','',''];
  //   this.failedAttempts = false;
  //   try {
  //     const response = await fetch(environment.baseApiUrl + 'user/v1/password/forgot', {
  //       method: 'PUT',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ email: this.resetEmail })
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       this.message.add({
  //         severity: 'success',
  //         summary: 'OTP Resent',
  //         detail: data.message || 'OTP has been resent to your email'
  //       });
  //       this.startResendCountdown();  // Restart countdown

  //     } else {
  //       this.message.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: data.message || 'Failed to Resend OTP'
  //       });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     this.message.add({
  //       severity: 'error',
  //       summary: 'Network Error',
  //       detail: 'Failed to send request. Please try again later.'
  //     });
  //   }
  // }

  async resendOtp() {

    this.otp = ['', '', '', '', '', ''];
    this.failedAttempts = false;




    try {
      const response = await fetch(environment.baseApiUrl + 'user/v1/password/forgot', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.resetEmail })
      });

      const data = await response.json();
      this.loading = true
      if (response.ok) {
        this.message.add({
          severity: 'success',
          summary: 'OTP Resent',
          detail: data.message || 'OTP has been resent to your email'
        });
        this.startResendCountdown();  // Restart countdown
      } else {
        this.message.add({
          severity: 'error',
          summary: 'Error',
          detail: data.message || 'Failed to Resend OTP'
        });
      }
    } catch (err) {
      console.error(err);
      this.message.add({
        severity: 'error',
        summary: 'Network Error',
        detail: 'Failed to send request. Please try again later.'
      });
    } finally {
      this.loading = false
    }

  }

  failedAttempts: boolean = false;
  // Clear timer when component is destroyed
  ngOnDestroy() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
    }
  }


  async verifyOtp() {
    const otpString = this.otp.join('');

    if (otpString.length !== 6 || this.otp.includes('')) {
      this.message.add({ severity: 'warn', summary: 'Incomplete OTP', detail: 'Please enter all 6 digits' });
      return;
    }
    this.loading = true
    try {
      const response = await fetch(environment.baseApiUrl + 'user/v1/password/verify/otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.resetEmail, otp: otpString })
      });
      const data = await response.json();
      if (response.ok) {
        this.message.add({ severity: 'success', summary: 'OTP Verified', detail: data.message || 'You may now reset your password' });
        this.step = 3;
        this.failedAttempts = false;
      } else {

        let attempt = data.attempt_reached;
        this.failedAttempts = attempt


        this.message.add({ severity: 'error', summary: 'Invalid OTP', detail: data.message || 'Please check and try again' });
        if (this.failedAttempts === true) {
          this.otp = ['', '', '', '', '', ''];
          clearInterval(this.resendTimer);

        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false
    }
  }

  async resetPassword() {
    if (this.newPassword !== this.confirmPassword) {
      this.message.add({ severity: 'error', summary: 'Mismatch', detail: 'Passwords do not match' });
      return;
    }
    this.loading = true
    try {
      const response = await fetch(environment.baseApiUrl + 'user/v1/reset/password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.resetEmail,
          password: this.step3Form.value.newPassword
        })
      });
      const data = await response.json();

      if (response.ok) {
        this.message.add({ severity: 'success', summary: 'Password Reset', detail: data.message || 'You can now log in' });
        this.showResetFlow = false;
        this.step = 1;
        this.resetEmail = '';
        this.otp.fill('');
        this.newPassword = '';
        this.confirmPassword = '';
      } else {
        this.message.add({ severity: 'error', summary: 'Reset Failed', detail: data.message || 'Try again' });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  onOtpChange(value: string, index: number): void {
    if (value.length > 1) {
      value = value.charAt(value.length - 1);
    }
    this.otp[index] = value;
  }

  cancelReset() {
    this.showResetFlow = false;
    this.step = 1;
    this.resetEmail = '';
    this.otp = ['', '', '', '', '', ''];
    this.newPassword = '';
    this.confirmPassword = '';
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
  }

  moveFocus(index: number, event: any) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    value = value.replace(/\D/g, '');

    if (value.length > 1) {
      value = value.charAt(0);
    }

    this.otp[index] = value;
    input.value = value;

    if (value && index < 5) {
      const nextInput = input.nextElementSibling as HTMLInputElement;
      nextInput?.focus();
    }

    if (!value && event.inputType === 'deleteContentBackward' && index > 0) {
      const prevInput = input.previousElementSibling as HTMLInputElement;
      prevInput?.focus();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }
  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  emailPhaseCompleted = false;
  userType: number | null = null;
  // async getUserTypeByEmail(email: string): Promise<number> {
  //   // Example logic — use API instead of this
  //   return email.includes('@cozentus.com') ? 10 : 15;
  // }
  async onEmailSubmit(): Promise<void> {
    const emailControl = this.loginForm.get('email');
    if (!emailControl || emailControl.invalid) {
      emailControl?.markAsTouched();
      return;
    }
  
    const email = emailControl.value;
    this.loading = true
    try {
      this.userType = await this.getUserTypeByEmail(email);
      if (this.userType === 15 || this.userType ===5) {
        this.emailPhaseCompleted = true; // Show password field
      } else if (this.userType === 10) {
        this.login();
      } else {
        this.message.add({
          severity: 'warn',
          summary: 'Unknown User Type',
          detail: `User type ${this.userType} is not supported.`
        });
      }
    } catch (error) {
      this.message.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.message
      });
    } finally {
      this.loading = false
    }
  }

  // async getUserTypeByEmail(email: string): Promise<number> {
  //   // Example logic — use API instead of this
  //   return email.includes('@cozentus.com') ? 10 : 15;
  // }

  
 async getUserTypeByEmail(email: string): Promise<number> {
   try {
     const response = await fetch(`${environment.baseApiUrl}user/v1/user-type-check/${email}`, {
       method: 'GET',
       headers: {
         'Content-Type': 'application/json',
       }
     });

     const data = await response.json();

     if (response.ok && data?.user_type !== undefined) {
       return data.user_type;
     } else {
       throw new Error(data?.message || 'Failed to fetch user type');
     }

   } catch (err) {
     console.error('Error fetching user type:', err);
     throw err;
   }
 }

}
